export default "__VITE_ASSET__B$VHuwDc__"